import * as Yup from "yup";

export const ReligionSchema = Yup.object().shape({
  name: Yup.string().required("Email is required"),
});
